import React from 'react';
import SafeIcon from '../../../common/SafeIcon';
import { Icons } from '../../../shared/icons';
import ClassificationSelector from './ClassificationSelector';

export default function GWNFaultStep({ 
  form, 
  setNestedField,
  addItem,
  removeItem,
  setField,
  errors = {}
}) {
  const faults = form.faults || [];

  return (
    <div className="gwn-fault-step">
      <div className="panel fault-panel">
        <h3>Identified Faults</h3>
        <p className="field-hint">Record all faults found that require the Warning Notice</p>
      </div>

      {faults.map((fault, index) => (
        <div key={index} className="fault-item cp12-section">
          <div className="cp12-section-header">
            <h4>Fault {index + 1}</h4>
            {faults.length > 1 && (
              <button
                type="button"
                className="cp12-remove"
                onClick={() => removeItem('faults', index)}
                aria-label={`Remove fault ${index + 1}`}
              >
                <SafeIcon icon={Icons.X} size={16} />
                Remove
              </button>
            )}
          </div>

          <label className="cert-field">
            Fault Location
            <input
              type="text"
              value={fault.location}
              onChange={(e) => setNestedField(`faults[${index}].location`, e.target.value)}
              placeholder="e.g. Kitchen boiler / Flue in loft"
              aria-label={`Fault ${index + 1} location`}
            />
          </label>

          <label className="cert-field">
            Fault Description
            <textarea
              value={fault.description}
              onChange={(e) => setNestedField(`faults[${index}].description`, e.target.value)}
              placeholder="Describe the fault in detail"
              rows={3}
              aria-label={`Fault ${index + 1} description`}
            />
          </label>

          <ClassificationSelector
            value={fault.classification}
            onChange={(value) => setNestedField(`faults[${index}].classification`, value)}
            perFault={true}
            errors={errors[`fault_${index}_classification`]}
          />

          <label className="cert-field">
            Immediate Action Taken
            <textarea
              value={fault.immediate_action}
              onChange={(e) => setNestedField(`faults[${index}].immediate_action`, e.target.value)}
              placeholder="What immediate action was taken?"
              rows={2}
              aria-label={`Fault ${index + 1} immediate action`}
            />
          </label>

          <label className="cert-field">
            Further Action Required
            <div className="toggle-group">
              <button
                type="button"
                className={`toggle-option ${fault.further_action_required === true ? 'selected' : ''}`}
                onClick={() => setNestedField(`faults[${index}].further_action_required`, true)}
                aria-label={`Mark fault ${index + 1} as requiring further action`}
                aria-pressed={fault.further_action_required === true}
              >
                <SafeIcon icon={Icons.Check} size={20} />
                YES
              </button>
              <button
                type="button"
                className={`toggle-option ${fault.further_action_required === false ? 'selected' : ''}`}
                onClick={() => setNestedField(`faults[${index}].further_action_required`, false)}
                aria-label={`Mark fault ${index + 1} as not requiring further action`}
                aria-pressed={fault.further_action_required === false}
              >
                <SafeIcon icon={Icons.X} size={20} />
                NO
              </button>
            </div>
          </label>
        </div>
      ))}

      <button
        type="button"
        className="secondary-button add-fault-button"
        onClick={() => addItem('faults', {
          location: '',
          description: '',
          classification: '',
          immediate_action: '',
          further_action_required: false
        })}
        aria-label="Add new fault"
      >
        <SafeIcon icon={Icons.Plus} size={18} />
        Add Fault
      </button>

      {errors.faults && (
        <div className="validation-errors">
          <span className="error-message">{errors.faults}</span>
        </div>
      )}
    </div>
  );
}